import { ReactNode } from 'react';

import { Box, Row, RowProps } from 'components/Blocks';
import { cn } from 'styles';

interface PropertyWithIconProps {
  children?: never;
  icon: ReactNode;
  name: string | ReactNode;
  value: string | ReactNode;
  gap?: RowProps['gap'];
  alignItems?: 'center' | 'flex-start';
  transparentIconBackground?: boolean;
  addColon?: boolean;
  containerClassName?: string;
}

export function PropertyWithIcon({
  icon,
  name,
  value,
  gap,
  alignItems = 'flex-start',
  transparentIconBackground = false,
  addColon = false,
  containerClassName,
}: PropertyWithIconProps): JSX.Element {
  return (
    <Row alignItems={alignItems} gap={gap} className={containerClassName}>
      <Row gap={gap} fullWidth={false}>
        <Box size={32} border="circle" className={cn(transparentIconBackground ? '' : 'bg-muted')}>
          {icon}
        </Box>

        <span className="inline-flex items-center gap-1 font-semibold">
          {name}
          {`${addColon ? ':' : ''}`}{' '}
        </span>
      </Row>

      {/* optical alignment */}
      <div className={cn(alignItems === 'flex-start' && 'mt-1')}>{value}</div>
    </Row>
  );
}
